/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { neuronVotingPowersGetApiV3NeuronVotingPowers } from "../../funcs/neuronVotingPowersGetApiV3NeuronVotingPowers.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApiV3NeuronVotingPowersRequest$inboundSchema
    .optional(),
};

export const tool$neuronVotingPowersGetApiV3NeuronVotingPowers: ToolDefinition<
  typeof args
> = {
  name: "neuron-voting-powers-get-api-v3-neuron-voting-powers",
  description: ``,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] =
      await neuronVotingPowersGetApiV3NeuronVotingPowers(
        client,
        args.request,
        { fetchOptions: { signal: ctx.signal } },
      ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
